export class SignedTimetable {
  date!: string;
  documentId!: string;
}
